import React, { useEffect, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useAppointmentModel } from "../appointmentModel";
import { IAppointmentDetail } from "../appointmentType";
import { useDictModel } from "@/views/base/dict/dictModel";
import YhTag from "@/components/YhTag";
import { momentFormat, formatNum } from "@/utils/utils";
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";

type statusType = {
    "appointment.transfer": string,
    "appointment.change": string,
    "appointment.create": string,
    [key: string]: any
}


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, descRows, descTotal, rowsDescTotal, loading,
        loadData, setSelectedRowKeys, setDescRows, reset
    } = useAppointmentModel();

    const { getTreeNodeName } = useDictModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    useEffect(() => {
        loadData()
    }, [])

    const onLook = (code: string) => {
        let supplierEditKey = "3-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: code, mode: "look", },
            true
        );
    }
    const statusColor: statusType = {
        "appointment.transfer": "green",
        "appointment.change": "red",
        "appointment.create": "cyan",
    }

    const defaultColumns: ColumnsType<IAppointmentDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1
        },
        {
            title: '预约单号',
            width: 160,
            dataIndex: 'appointmentCode',
            render: (text: any) => <YhTootip text={text} style={{ width: 150 }} onClick={() => onLook(text)} />,
        },
        {
            title: '预约状态',
            width: 80,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={getTreeNodeName(text)} />,

        }, {
            title: '客户名称',
            width: 150,
            dataIndex: 'customerName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '送修人',
            width: 150,
            dataIndex: 'contact',
        }, {
            title: '送车电话',
            width: 95,
            dataIndex: 'phone',
        }, {
            title: '车牌号',
            width: 80,
            dataIndex: 'licensePlate',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: 'VIN码',
            width: 80,
            dataIndex: 'vin',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '车辆类型',
            width: 150,
            dataIndex: 'vehicleTypeName',
            render: (text: any) => <YhTootip text={text} style={{ width: '150px' }} />,
        }, {
            title: '车辆型号',
            width: 80,
            dataIndex: 'vehicleModel',

        }, {
            title: '车辆品牌',
            width: 160,
            dataIndex: 'brandName',
            render: (text: any) => <YhTootip text={text} style={{ width: '160px' }} />,
        }, {
            title: '维修类型',
            width: 80,
            dataIndex: 'serviceNatureName',
        }, {
            title: '工时费',
            width: 80,
            dataIndex: 'workingHoursAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '配件费',
            width: 80,
            dataIndex: 'materialScienceAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '费用合计',
            width: 110,
            dataIndex: 'totalAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '优惠金额',
            width: 80,
            dataIndex: 'discountTotalAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '营业额',
            width: 110,
            dataIndex: 'receivableTotalAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '销售毛利',
            width: 80,
            dataIndex: 'grossProfit',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '销售成本',
            width: 80,
            dataIndex: 'totalCost',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '结算类型',
            width: 80,
            dataIndex: 'payType',
            render: (text) => getTreeNodeName(text)
            // }, {
            //     title: '结算方式',
            //     width: 160,
            //     dataIndex: 'fax',
        }, {
            title: '结算方',
            width: 80,
            dataIndex: 'settlementPartyName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '服务地点',
            width: 90,
            dataIndex: 'serviceLocationName',
        }, {
            title: '预约进厂时间',
            width: 130,
            dataIndex: 'enterTime',
            render: (text) => momentFormat(text)
        }, {
            title: '预估出厂时间',
            width: 130,
            dataIndex: 'deliveryTime',
            render: (text) => momentFormat(text)
        }, {
            title: '制单员',
            width: 60,
            dataIndex: 'createUser',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '作废原因',
            width: 120,
            dataIndex: 'cancelReason',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        }, {
            title: '打印次数',
            width: 90,
            align: "center",
            dataIndex: 'printingTimes',
        },
        {
            title: '工单单号',
            width: 150,
            dataIndex: 'maintenanceCode',
            render: (text: any) => <YhTootip text={text} style={{ width: 150 }} />,
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "appointment", "roleCodes": roles };
        return getRoleColumns("appointment", "主单", defaultColumns, params);
    }, [roles, dataSource]);

    //点击行选高亮
    const onRow = (record: IAppointmentDetail) => {
        // let findIndex = selectedRowKeys.indexOf(id);
        // let newSelectedRowKeys = [...selectedRowKeys];
        // if (findIndex === -1) {
        //     newSelectedRowKeys.push(id);
        //     setSelectedRowKeys(newSelectedRowKeys);
        // } else {
        //     newSelectedRowKeys.splice(findIndex, 1);
        //     setSelectedRowKeys(newSelectedRowKeys);
        // }
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    const onRightClick = (record: IAppointmentDetail) => {
        setDescRows([record])
        setSelectedRowKeys([record.id as string])
    }
    const countX = (arr: any) => {
        return arr.reduce((cur: any, next: any) => {
            return cur + (next.width ? next.width : 0)
        })
    }
    return (
        <Table
            bordered
            style={{ cursor: "pointer" }}
            loading={loading}
            size={tableSize}
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: IAppointmentDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record as IAppointmentDetail),
                onContextMenu: (e) => {
                    e.preventDefault();
                    // setSelectedRowKeys([record.id as string]);
                    onRightClick(record)
                }

            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 370px)' }}
            summary={() => (
                <Table.Summary fixed>
                    <Table.Summary.Row className="table-total-box">
                        <Table.Summary.Cell index={0}>
                            <div className="title">合计</div>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={1} >
                            <span className="green">{selectedRowKeys.length === 0 ? descTotal.num : rowsDescTotal.num}</span>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={2} />
                        <Table.Summary.Cell index={3} />
                        <Table.Summary.Cell index={4} />
                        <Table.Summary.Cell index={5} />
                        <Table.Summary.Cell index={6} />
                        <Table.Summary.Cell index={7} />
                        <Table.Summary.Cell index={8} />
                        <Table.Summary.Cell index={9} />
                        <Table.Summary.Cell index={10} />
                        <Table.Summary.Cell index={11} />
                        <Table.Summary.Cell index={12} />
                        <Table.Summary.Cell index={13} />
                        <Table.Summary.Cell index={14} />
                        <Table.Summary.Cell index={15} />
                        {/* >
                            <span className="red">{selectedRowKeys.length === 0 ? descTotal.totalAmount : formatNum(rowsDescTotal.totalAmount)}</span>
                        </Table.Summary.Cell> */}
                        <Table.Summary.Cell index={16} />
                        <Table.Summary.Cell index={17} />
                        {/* >
                            <span className="red">{selectedRowKeys.length === 0 ? descTotal.receivableTotalAmount : formatNum(rowsDescTotal.receivableTotalAmount)}</span>
                        </Table.Summary.Cell> */}
                        <Table.Summary.Cell index={18} />
                        <Table.Summary.Cell index={19} />
                        <Table.Summary.Cell index={20} />
                        <Table.Summary.Cell index={21} />
                        <Table.Summary.Cell index={22} />
                        <Table.Summary.Cell index={23} />
                        <Table.Summary.Cell index={24} />
                        <Table.Summary.Cell index={25} />
                        <Table.Summary.Cell index={26} />
                        <Table.Summary.Cell index={27} />
                        <Table.Summary.Cell index={28} />
                        <Table.Summary.Cell index={29} />
                    </Table.Summary.Row>
                </Table.Summary>
            )}
        />
    )
}
